var jQuery = $;
import slick from '../../node_modules/slick-carousel/slick/slick.min.js';
import fancy from '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import '../../node_modules/swiper/swiper-bundle.js';
import Macy from '../../node_modules/macy/dist/macy';
console.log('app.js');
const app = {
    /** Initialize */
    init() {
        // Open search overlay
        this.toggleSearchOverlay();

        // Fade sections in on scroll
        this.fadeInOnScroll();

        // Init swiper
        this.initSwiperSliders();

        // Pageheader scroll
        this.pageheaderScroll();

        this.toggleActiveFilterStates();

        // this.removeAndShowNavigationOnScroll();

        this.toggleHeadings();

        this.toggleFaqCategories();

        this.toggleTimelineSlider();

        this.checkFormFields();

        this.masonry();

        // Smooth anchor
        this.smoothAnchor();

        $(window).on('scroll', $.proxy(this.windowScrollHandler, this));
        $('.hamburger, .navigation-overlay').on('click', $.proxy(this.toggleHamburgerMenu, this));
        $('.open-popup, .close-popup, .popup-overlay, a[href="#inschrijven"]').on('click', $.proxy(this.togglePopup, this))

        // if ($(window).width() > 1200) {

            $('.video-wrapper').on("mousemove", function(event) {
                const wrapperOffset = $(this).offset();
                const x = event.pageX - wrapperOffset.left - 60;
                const y = event.pageY - wrapperOffset.top - 60;
                const cursor = $("#cursor");
                cursor.css("left", x + "px");
                cursor.css("top", y + "px");
            });
            
            $(".video-wrapper").on("mouseover", function(){
                $("#cursor").css("transform", "scale(1)");
            });
            
            $(".video-wrapper").on("mouseleave", function(){
                $("#cursor").css("transform", "scale(0)");
            });

            // $('.video-container .content').on('mousemove', function () {
            //     $("#cursor").css("transform", "scale(0)");
            // })

            // $('.video-container .content').on('mouseleave', function () {
            //     $("#cursor").css("transform", "scale(1)");
            // })
        // }
    },

    /** Open hamburger menu */
    toggleHamburgerMenu() {
        $('.hamburger').toggleClass('is-active');
        $('body').toggleClass('is-locked');
        $('.navigation-items nav.navigation').toggleClass('is-visible');
        $('.navigation-overlay').toggleClass('is-visible');
    },

    /** Handles the scroll event */
    windowScrollHandler() {
        $('header').toggleClass('is-scrolled', $(window).scrollTop() > 0);
    },

    /** Open search overlay */
    toggleSearchOverlay() {

        $('.toggle-search-box, .search-box .close-search-box').click(function (e) {
            e.preventDefault();
            $(".search-box").toggleClass('is-opened');
        });
    },

    /** Open popup */
    togglePopup() {
        $(".popup").toggleClass('active');
        $(".popup-overlay").toggleClass('active');
        $("body").toggleClass('is-locked');
    },

    /** Fade sections in on scroll */
    fadeInOnScroll() {
        $.fn.initFadeIn = function () {
            $('.section').each(function () {
                let top_of_element = $(this).offset().top + 150;
                let bottom_of_element = $(this).offset().top + $(this).outerHeight();
                let bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
                let top_of_screen = $(window).scrollTop();
                if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element) && !$(this).hasClass('is-visible')) {
                    $(this).addClass('is-visible');
                }
            });
        };
        $.fn.initFadeIn();
        $(window).scroll(function () {
            $.fn.initFadeIn();
        });
    },

    checkFormFields() {

        $(document).ready(function () {

            $(".section-form input[type='radio']").click(function () {
                if ($(this).is(":checked")) {
                    $(this).parent().addClass('checked');
                } else {
                    $(this).parent().removeClass('checked');
                }
            });

        });

    },

    /** Smooth scroll to Anchor */
    smoothAnchor() {
        var $root = $('html, body');

        $('a[href^="#"]:not(.open-popup, a[href="#inschrijven"])').click(function (e) {
            e.preventDefault();
            $root.animate({
                scrollTop: $($.attr(this, 'href')).offset().top - 100
            }, 500);

            return false;
        });
    },

    initSwiperSliders() {
        const thumbSwiper = new Swiper('.timeline-horizontal-slider', {
            spaceBetween: 10,
            slidesPerView: 2,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                767: {
                    slidesPerView: 4,
                }
            }
        });

        const swiperTimeline = new Swiper('.timeline-slider', {
            slidesPerView: 1,
            loop: false,
            spaceBetween: 0,
            navigation: {
                prevEl: '.swiper-arrow.prev',
                nextEl: '.swiper-arrow.next',
            },
            thumbs: {
                swiper: thumbSwiper,
            },
        });

        $('.section-timeline .timeline .timeline-items .timeline-item:not(.active)').click(swiperTimeline, function () {
            let slideId = $(this).data('slide-id');
            if (slideId) {
                swiperTimeline.slideTo(slideId - 1);
                $('.timeline-item.active').removeClass('active');
                $(this).addClass('active');
            }
        });

        $('.section-timeline .swiper-arrows .swiper-arrow').click(swiperTimeline, function () {
            let index = swiperTimeline.activeIndex + 1;
            $('.timeline-items .timeline-item.active').removeClass('active');
            $('.timeline-items .timeline-item[data-slide-id="' + index + '"]').addClass('active');
        });

        const swiperReviews = new Swiper('.reviews-slider', {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 0,
            grabCursor: true,
            navigation: {
                prevEl: '.reviews-slider-wrapper .intro-actions.show-md .slider-arrows .swiper-button-prev',
                nextEl: '.reviews-slider-wrapper .intro-actions.show-md .slider-arrows .swiper-button-next',
            },
            pagination: {
                el: ".reviews-slider-wrapper .intro-actions.show-md .swiper-pagination",
            },
            breakpoints: {
                480: {
                    slidesPerView: 1.1,
                },
                768: {
                    slidesPerView: 1.8,
                },
                1025: {
                    slidesPerView: 2.4,
                    navigation: {
                        prevEl: '.intro .slider-arrows .swiper-button-prev',
                        nextEl: '.intro .slider-arrows .swiper-button-next',
                    },
                }
            }
        });

        const swiperBlog = new Swiper('.blog-image-slider', {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 40,
            pagination: {
                el: ".swiper-pagination",
            },
        });

        const swiperEcho = new Swiper('.echo-slider', {
            slidesPerView: 1,
            loop: false,
            spaceBetween: 80,
            navigation: {
                prevEl: '.slider-controls-small .slider-arrows .swiper-button-prev',
                nextEl: '.slider-controls-small .slider-arrows .swiper-button-next',
            },
            pagination: {
                el: ".slider-controls-small .swiper-pagination.swiper-pagination-bottom",
            },
            breakpoints: {
                480: {
                    spaceBetween: 40,
                    slidesPerView: "auto",
                    pagination: {
                        el: ".slider-controls-small .swiper-pagination.swiper-pagination-bottom",
                    },
                    navigation: {
                        prevEl: '.slider-controls-small .slider-arrows .swiper-button-prev',
                        nextEl: '.slider-controls-small .slider-arrows .swiper-button-next',
                    },
                },
                769: {
                    spaceBetween: 40,
                    slidesPerView: "auto",
                    pagination: {
                        el: ".slider-controls-small .swiper-pagination.swiper-pagination-bottom",
                    },
                    navigation: {
                        prevEl: '.slider-controls-small .slider-arrows .swiper-button-prev',
                        nextEl: '.slider-controls-small .slider-arrows .swiper-button-next',
                    },
                },
                1025: {
                    spaceBetween: 80,
                    slidesPerView: "auto",
                    navigation: {
                        prevEl: '.echo-slider-intro .slider-arrows .swiper-button-prev',
                        nextEl: '.echo-slider-intro .slider-arrows .swiper-button-next',
                    },
                    pagination: {
                        el: ".echo-slider-intro .swiper-pagination",
                    },
                }
            }
        });

        if ($(window).width() < 413) {
            // const swiperServices = new Swiper('.services-slider.slider', {
            //     slidesPerView: 1.5,
            //     loop: false,
            //     spaceBetween: 20,
            //     navigation: {
            //         prevEl: '.swiper-button-prev',
            //         nextEl: '.swiper-button-next',
            //     },
            //     pagination: {
            //         el: ".swiper-pagination",
            //     },
            // });

            // Per slider, zodat een teamblok met open bio's (optie "Bio open", 05-10-2026) mee kan groeien met de
            // kaart die in beeld is. Anders staat er onder een korte bio de lege ruimte van de langste.
            document.querySelectorAll('.team-slider').forEach((el) => {
                new Swiper(el, {
                    slidesPerView: 1,
                    loop: false,
                    spaceBetween: 20,
                    autoHeight: !!el.closest('.bio-open'),
                    navigation: {
                        prevEl: el.querySelector('.swiper-button-prev'),
                        nextEl: el.querySelector('.swiper-button-next'),
                    },
                });
            });
        }
    },

    pageheaderScroll() {
        $('.pageheader-scroll').on('click', function () {
            $('html, body').animate({
                scrollTop: $(window).height() - 35
            }, 'slow');
        });
    },

    toggleActiveFilterStates() {
        $(document).on('click', '.section-cases-overview .filter-categories .filter-link-item, .section-news-overview .filter-categories .filter-link-item', function () {
            e.preventDefault();
            if (!$(this).hasClass('is-active')) {
                $('.section-cases-overview .filter-categories .filter-link-item').each(function () {
                    if ($(this).hasClass('is-active')) {
                        $(this).removeClass('is-active');
                    }
                });

                $(this).addClass('is-active');
            }
        });
    },

    // removeAndShowNavigationOnScroll() {

    //     var lastScrollTopPosition;

    //     let header = document.getElementById('header');

    //     window.addEventListener('scroll', function () {
    //         let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    //         if (scrollTop > lastScrollTopPosition) {
    //             if (window.innerWidth > 1024) {
    //                 header.style.top = '-80px';
    //             } else {
    //                 header.style.top = '-70px';
    //             }
    //         } else {
    //             header.style.top = '0';
    //         }

    //         lastScrollTopPosition = scrollTop;
    //     });
    // },

    toggleHeadings() {
        $('.toggle-heading').on('click', function () {
            if ($(this).parent().find('.toggle-content').hasClass('hidden')) {
                $(this).parent().find('.toggle-content.hidden').slideDown(500);
                $(this).parent().find('.toggle-content.hidden').removeClass('hidden');
                $(this).find('.toggle-icon').removeClass('fa-plus').addClass('fa-minus');
            } else {
                $(this).parent().find('.toggle-content').slideUp(500);
                $(this).parent().find('.toggle-content').addClass('hidden');
                $(this).find('.toggle-icon').removeClass('fa-minus').addClass('fa-plus');
            }

        });

        //Set item open when ancher match with item ID
        let anchor = window.location.hash.substr(1);
        let scroll = '#' + anchor;
        if (anchor != '' && anchor != 'inschrijven') {
            window.scrollTo(0, 0);

            $('html,body').animate({
                scrollTop: $(scroll).offset().top - 150
            }, 'slow');

            history.pushState("", document.title, window.location.pathname + window.location.search);
            if ($("#" + anchor).length != 0) {
                $('#' + anchor + '').find('.toggle-content.hidden').slideDown(500);
                $('#' + anchor + '').find('.toggle-content.hidden').removeClass('hidden');
                $('#' + anchor + '').find('.toggle-icon').removeClass('fa-plus').addClass('fa-minus');
            }
        }
    },

    toggleFaqCategories() {
        $('.category-link').on('click', function (e) {
            e.preventDefault();

            let currentAttrValue = $(this).attr('href');
            console.log(currentAttrValue);

            $('html, body').animate({
                scrollTop: $(currentAttrValue).offset().top
            }, 1000);

        });

    },

    toggleTimelineSlider() {
    },

    masonry() {
        if ($('.reviews-wrapper').length) {
            let macyInstance = Macy({
                columns: 3,
                container: '.reviews-wrapper',
                margin: 25,
                breakAt: {
                    1024: 2,
                    767: 1
                }
            });
        }
    }

};
$(document).ready($.proxy(app.init, app));
